var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"canvas-container",attrs:{"id":"DiaryGraph"}},[_c('canvas',{ref:"clockCanvas",staticClass:"clock-canvas",attrs:{"id":"PlanClock","height":_vm.CANVAS_HEIGHT,"width":_vm.CANVAS_WIDTH}})])
}
var staticRenderFns = []

export { render, staticRenderFns }